/*
  FaD - restore product_added_to_cart for all storefront pixels
  --------------------------------------------------------------
  WHY THIS EXISTS
  fad-theme-v5-57 adds items with a custom fetch to /cart/add.js and never calls
  Shopify.analytics.publish('product_added_to_cart'). Shopify's Web Pixels API is
  event driven, so nothing is forwarded and every pixel on the store is blind to
  add to cart: Meta, Google & YouTube, Klaviyo and TikTok.

  WHAT THIS DOES
  Wraps fetch and XMLHttpRequest, watches for a successful POST to /cart/add(.js),
  and publishes the standard product_added_to_cart event with the payload shape
  Shopify's pixels expect. Catches all six theme call sites plus any app that adds
  through the same endpoint, including Kaching Bundles.

  INSTALL
  1. Shopify admin > Online Store > Themes > Duplicate the live theme first.
  2. On the duplicate: Edit code > Assets > Add a new asset > name it
     fad-cart-pixel-fix.js and paste this file.
  3. Open layout/theme.liquid and add this line immediately before </head>:
       <script src="{{ 'fad-cart-pixel-fix.js' | asset_url }}" defer></script>
     It must load before theme.js so the wrappers are installed first.
  4. Preview the duplicate, add a kit to cart, and confirm the event arrives in
     Meta Events Manager > Test events.
  5. Only then publish the duplicate.

  SAFETY
  Fails silently if Shopify.analytics is unavailable. Never blocks or alters the
  cart request itself; it only observes the response.
*/
(function () {
  'use strict';
  if (window.__fadCartPixelPatch) return;
  window.__fadCartPixelPatch = true;

  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  function currency() {
    try { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD'; }
    catch (e) { return 'AUD'; }
  }

  function money(cents) {
    return typeof cents === 'number' ? cents / 100 : 0;
  }

  function publishAdd(items) {
    var api = window.Shopify && window.Shopify.analytics;
    if (!api || typeof api.publish !== 'function') return;
    var cc = currency();

    (items || []).forEach(function (item) {
      if (!item) return;
      try {
        api.publish('product_added_to_cart', {
          cartLine: {
            cost: {
              totalAmount: {
                amount: money(item.final_line_price != null ? item.final_line_price : item.line_price),
                currencyCode: cc
              }
            },
            merchandise: {
              id: String(item.variant_id != null ? item.variant_id : item.id),
              price: {
                amount: money(item.final_price != null ? item.final_price : item.price),
                currencyCode: cc
              },
              product: {
                id: String(item.product_id || ''),
                title: item.product_title || item.title || '',
                vendor: item.vendor || '',
                type: item.product_type || '',
                untranslatedTitle: item.product_title || item.title || '',
                url: item.url || ''
              },
              sku: item.sku || '',
              title: item.variant_title || '',
              untranslatedTitle: item.variant_title || ''
            },
            quantity: item.quantity || 1
          }
        });
      } catch (e) { /* never break the cart */ }
    });
  }

  function itemsFrom(data) {
    if (!data) return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.id || data.variant_id) return [data];
    return [];
  }

  /* ---- fetch ---- */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var url = '';
      try {
        url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      } catch (e) {}
      var promise = origFetch.apply(this, arguments);
      if (CART_ADD.test(url)) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (data) {
            publishAdd(itemsFrom(data));
          }).catch(function () {});
        }).catch(function () {});
      }
      return promise;
    };
  }

  /* ---- XMLHttpRequest ---- */
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__fadCartAdd = CART_ADD.test(String(url)); } catch (e) { this.__fadCartAdd = false; }
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__fadCartAdd) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        try { publishAdd(itemsFrom(JSON.parse(this.responseText))); } catch (e) {}
      });
    }
    return origSend.apply(this, arguments);
  };
})();
